import { PictureBoxBaseCustomElement } from 'General/Resources/Elements/PictureBox/PictureBoxBase';
import { autoinject, customElement } from 'aurelia-framework';

@autoinject
@customElement('picture-box')
export class PictureBoxCustomElement extends PictureBoxBaseCustomElement { }